// extracted by mini-css-extract-plugin
export default {"container":"styles_container__n5hgS","whitespace":"styles_whitespace__jcEu4","controls":"styles_controls__oI2Ra","controlButton":"styles_controlButton__kQiJ7"};